import { Directive, Input } from '@angular/core';
import { UntypedFormControl, NG_VALIDATORS, Validator } from '@angular/forms';
import { DateHelper } from 'app/main/content/misc/date.module';

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[customMaxDate][formControlName],[customMaxDate][formControl],[customMaxDate][ngModel]',
  providers: [{provide: NG_VALIDATORS, useExisting: CustomMaxDateDirective, multi: true}],
})
export class CustomMaxDateDirective implements Validator {
  @Input() customMaxDate: number;

  constructor(private dateHelper: DateHelper){}

  validate(c: UntypedFormControl): {[key: string]: any} {
    const v = c.value;
    if (v && this.customMaxDate){
      const d = this.dateHelper.utc(v, 'DD/MMM/YYYY');
      const max = this.dateHelper.utc(this.customMaxDate, 'DD/MMM/YYYY');
      if (d.isValid() && max.isValid()){
        return (d > max.add(2, 'hours')) ? {customMaxDate: true} : null;
      }
      else{
        return null;
      }
    }
    else {
      return null;
    }
  }
}
